
import { defineComponent } from "vue";
import Modal from "../Components/Modal.vue";
import appRestService from "../../protocol/rest-service";
import AppConfig from "@/config/app-config";
import gameApplication from "../../game/game-app";

export default defineComponent({
  name: "UserModal",

  computed: {
    progress: () => '47%',
  },

 methods: {
    async getDetails(): Promise<void> {

      const player = gameApplication.getPlayer().player;
      const userId = player.playerId;

      const res = await appRestService.post(AppConfig.WEB_SITE_REST_API + 'account?userid=', userId);

      if (res.data) {
        console.log('Loaded data', res.data);
      }
    }
 },

  components: { Modal },
});
